module.exports = __webpack_public_path__ + "img/createfolder.fdf98dd9.svg";